var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeftMessage = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#404C60",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.5 24c-1.25 0-2.313-.438-3.188-1.313C10.438 21.813 10 20.75 10 19.5c0-1.25.438-2.313 1.313-3.188C12.187 15.438 13.25 15 14.5 15c1.25 0 2.313.438 3.188 1.313S19 18.25 19 19.5c0 .45-.067.883-.2 1.3a5.56 5.56 0 0 1-.55 1.2h3.5a5.56 5.56 0 0 1-.55-1.2 4.24 4.24 0 0 1-.2-1.3c0-1.25.438-2.313 1.313-3.188S24.25 15 25.5 15c1.25 0 2.313.438 3.188 1.313S30 18.25 30 19.5c0 1.25-.438 2.313-1.313 3.188S26.75 24 25.5 24h-11Zm0-2c.7 0 1.292-.242 1.775-.725.483-.483.725-1.075.725-1.775s-.242-1.292-.725-1.775C15.792 17.242 15.2 17 14.5 17s-1.292.242-1.775.725C12.242 18.208 12 18.8 12 19.5s.242 1.292.725 1.775c.483.483 1.075.725 1.775.725Zm11 0c.7 0 1.292-.242 1.775-.725.483-.483.725-1.075.725-1.775s-.242-1.292-.725-1.775C26.792 17.242 26.2 17 25.5 17s-1.292.242-1.775.725C23.242 18.208 23 18.8 23 19.5s.242 1.292.725 1.775c.483.483 1.075.725 1.775.725Z"
})));
SvgLeftMessage.viewBox = '0 0 40 40';
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeftMessage);
export default ForwardRef;